
import { Component, Prop, Vue } from 'vue-property-decorator'
import { RouterUtils } from '@/commons/utils/router'

@Component
export default class LoadingSpinner extends Vue {
    @Prop({ default: '' }) afterLoadingFocusQuery!: string

    mounted (): void {
        const spinner = document.getElementById('loading-text')
        if (spinner) {
            spinner.setAttribute('tabindex', '-1')
            spinner.focus()
        }
    }

    destroyed (): void {
        if (this.afterLoadingFocusQuery === '') {
            RouterUtils.setFocusToBody()
        } else {
            RouterUtils.setFocusToElement(this.afterLoadingFocusQuery)
        }
    }
}
